export default "__VITE_ASSET__Dv1qX_cB__"